import store from '../../stores'

import * as fromMaterials from '../../stores/ducks/materials'

export default function handleMaterials (msg) {
  store.dispatch(fromMaterials.receive(msg.doc))
}
